import { render, staticRenderFns } from "./PendingSchoolBooking.vue?vue&type=template&id=1f6e6aee&scoped=true"
import script from "./PendingSchoolBooking.vue?vue&type=script&lang=js"
export * from "./PendingSchoolBooking.vue?vue&type=script&lang=js"
import style0 from "./PendingSchoolBooking.vue?vue&type=style&index=0&id=1f6e6aee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6e6aee",
  null
  
)

export default component.exports